var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "add-appointment view" }, [
    _c(
      "div",
      { staticClass: "view_content" },
      [
        _c("transition", { attrs: { mode: "out-in" } }, [
          _c("div", { staticClass: "view_content_markdownmg mg--b-7" }, [
            _c("h1", { staticClass: "center" }, [
              _vm._v(_vm._s(_vm.$t("appointment.appointmentContainer.title"))),
            ]),
            _c("p", { staticClass: "center" }, [
              _vm._v(_vm._s(_vm.$t("appointment.appointmentContainer.text"))),
            ]),
            _c(
              "div",
              { staticClass: "confirm-sinister-info_calendar-wrapper" },
              [
                _c("ma-appointment-calendar", {
                  staticClass: "mg mg--b-7",
                  attrs: { availableDates: _vm.availableDates },
                  on: { clickDate: _vm.handleClickDate },
                }),
                _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
                  _vm.selectedDate
                    ? _c(
                        "p",
                        { staticClass: "text-medium gray mg mg--b-4 center" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("appointment.appointmentContainer.text2")
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _c(
                  "transition",
                  { attrs: { name: "fade", mode: "out-in" } },
                  [
                    _c("ma-appointment-hours", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isHoursVisible,
                          expression: "isHoursVisible",
                        },
                      ],
                      attrs: {
                        availableHours: _vm.availableHours,
                        selectedHour: _vm.selectedHour.from,
                      },
                      on: { clickHour: _vm.handleClickHour },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "view_actions" },
      [
        _c(
          "ma-actions-buttons",
          {
            attrs: {
              handleButtonClick: _vm.handlePrimaryButtonClick,
              handleButtonClickWhiteBtn: _vm.handleSecondaryButtonClick,
              title: _vm.$t("appointment.appointmentContainer.actions.primary"),
              titleWhiteBtn: _vm.$t(
                "appointment.appointmentContainer.actions.secondary"
              ),
              helperMainWhiteText: _vm.$t(
                "appointment.appointmentContainer.actions.secondaryHelpText"
              ),
              mainBlueShouldBeDisabled: _vm.primaryButtonIsDisabled,
              btnType: _vm.getBtnType,
            },
          },
          [
            _vm.isE2EFlow
              ? _vm._t("default", function () {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn mainWhite",
                        on: { click: _vm.handleTertiaryButtonClick },
                      },
                      [
                        _c("p", { staticClass: "text-medium" }, [
                          _vm._v(
                            _vm._s(_vm.$t("damageValidation.actions.tertiary"))
                          ),
                        ]),
                      ]
                    ),
                  ]
                })
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }